// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"310":"c7f47bc338dcfb4c","759":"dcc320a7c73abbb1","1095":"50183aadca606e0e","1260":"e0185e6afd420c19","1947":"2bba879d9a252b5c","8989":"73e41c718866c58e"}[chunkId] + ".css";
};